import React, { useState, useEffect, useCallback, useRef } from 'react';
import { buildApiUrl, getAuthHeaders } from '../../config/api';
import { useRestaurant } from '../../context/RestaurantContext';
import { notify, confirm } from '../../context/FeedbackContext';
import './CategoriesPage.css';
import axios from 'axios';
import { FaSearch } from 'react-icons/fa';
import { FiPlusCircle, FiEdit2 } from 'react-icons/fi';
import { getFilteredNavItemsWithIcons, getRouteFromItem } from '../../config/routes';

const EMPTY_FORM = {
  catName: '',
  catDesc: '',
  status: 1,
  printerName: '',
  printerReference: '',
  catPic: '',
  isTake: '', // Assuming isTake is a number, defaulting to 0
};

function CategoriesPage({ onNavigate }) {
  const { selectedRestaurant } = useRestaurant() || {};
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');
  const [view, setView] = useState('list');
  const [form, setForm] = useState(EMPTY_FORM);
  const [formErrors, setFormErrors] = useState({});

  const [categories, setCategories] = useState([]);

  const [originalForm, setOriginalForm] = useState(EMPTY_FORM);
  const [editingId, setEditingId] = useState(null);

  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState('');
  const imageInputRef = useRef(null);

  const [remarks, setRemarks] = useState([]);
  const [originalRemarks, setOriginalRemarks] = useState([]);
  const [remarkInput, setRemarkInput] = useState('');
  const [showRemarkInput, setShowRemarkInput] = useState(false);

  // 打印机列表
  const [prinList, setPrinList] = useState([]);

  const handleNavClick = (item) => {
    if (onNavigate) onNavigate(item);
  };

  // Filtering
  const statusLabel = (status) => status === 1 ? 'Published' : 'Unpublished';

  const filtered = categories.filter(c => {
    const matchesSearch =
      (c.catName || '').toLowerCase().includes(search.toLowerCase());
    const matchesStatus = statusFilter === 'All' || statusLabel(c.status) === statusFilter;
    return matchesSearch && matchesStatus;
  });

  // Fetching categories from database
  const fetchCategories = async (tenantRef) => {
    if (!tenantRef) return;
    setIsLoading(true);
    try {
      const response = await axios.get(
        buildApiUrl(`/catalog/category/list?tenantReference=${tenantRef}`),
        { headers: getAuthHeaders() }
      );
      setCategories(response.data.data);
    } catch (err) {
      notify(err, 'error');
      console.error("Failed to fetch categories", err);
    } finally {
      setIsLoading(false);
    }
  };

  // 查询打印机
  const getPrintIn = async (tenantRef) => {
    if (!tenantRef) return;
    try {
      const getPrintInList = await axios.get(
        buildApiUrl(`/setting/printers/by-tenant?tenantReference=${tenantRef}`),
        { headers: getAuthHeaders() }
      );
      console.log("getPrintInList====>", getPrintInList.data.data);
      setPrinList(getPrintInList.data.data);
    } catch (err) {
      notify(err, 'error');
      console.error("Failed to fetch printers", err);
    }
  };


  
  useEffect(() => {
    console.log("view==>",view);
  }, [view]); // eslint-disable-line react-hooks/exhaustive-deps


  useEffect(() => {
    fetchCategories(selectedRestaurant?.reference);
    getPrintIn(selectedRestaurant?.reference);
  }, [selectedRestaurant]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchRemarks = useCallback(async (catId, fallback = []) => {
    try {
      const response = await fetch(buildApiUrl(`/remark?catId=${catId}`), { headers: getAuthHeaders() });
      const data = await response.json();
      if (data.code === 200) {
        const list = data.items || [];
        const resolved = list.length > 0 ? list : fallback;
        setRemarks(resolved);
        setOriginalRemarks(resolved);
      }
    } catch (err) {
      console.error('Failed to fetch remarks', err);
    }
  }, []);

  // Setting of Category Creation
  const openAdd = () => {
    setForm({ ...EMPTY_FORM });
    setOriginalForm({ ...EMPTY_FORM });
    setImageFile(null);
    setImagePreview('');
    setRemarks([]);
    setOriginalRemarks([]);
    setRemarkInput('');
    setFormErrors({});
    setView('add');
  };

  // Setting of Category Update/Edit
  const openEdit = (category) => {
    console.log("Opening Edit for Category:", category);

    const editForm = {
      reference: category.reference,
      catName: category.catName,
      catDesc: category.catDesc,
      status: category.status,
      printerName: category.printerName || '',
      printerReference: category.printerReference || '',
      catPic: category.catPic || '',
      isTake: category.isTake != null ? String(category.isTake) : '',
    };

    setForm(editForm);
    setOriginalForm({ ...editForm });

    setImageFile(null);
    // setImagePreview(category.catPic ? buildApiUrl(`/file/view?fileName=${category.catPic.split('/').pop()}`) : '');
    setImagePreview(category.catPic ?? '');

    if (category.remarks && category.remarks.length > 0) {
      setRemarks(category.remarks.map((r, index) => ({
        id: index,
        remark_name: r.remarkName
      })));
      setOriginalRemarks(category.remarks.map((r, index) => ({
        id: index,
        remark_name: r.remarkName
      })));
    } else {
      setRemarks([]);
      setOriginalRemarks([]);
    }

    setFormErrors({});
    setView('edit');
  };

  const backToList = () => {
    setView('list');
    setForm(EMPTY_FORM);
    setFormErrors({});
    setImageFile(null);
    setImagePreview('');
  };

  const addRemark = () => {
    const name = remarkInput.trim();
    if (!name) { setShowRemarkInput(false); return; }
    setRemarks(prev => [...prev, { id: null, remark_name: name }]);
    setRemarkInput('');
    setShowRemarkInput(false);
  };

  const removeRemark = (index) => {
    setRemarks(prev => prev.filter((_, i) => i !== index));
  };

  // status 字段转数字
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: name === 'status' ? Number(value) : value,
    }));
    setFormErrors(prev => ({ ...prev, [name]: undefined }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImageFile(file);
    setImagePreview(URL.createObjectURL(file));
  };

  //  打印机选择
  const handleFormChangePrint = (e) => {
    console.log(e);
    const selectedRef = e.target.value;
    const selectedPrinter = prinList.find(p => p.reference === selectedRef);


    setForm((prev) => ({
      ...prev,
      printerReference: selectedRef,
      printerName: selectedPrinter ? selectedPrinter.printerName : '',

    }));
    setFormErrors(prev => ({ ...prev, printerReference: undefined }));
  };

  // 是否是isTake选择
  const handleFormChangeisTak = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));

    // 如果选择后清除错误提示
    if (formErrors[name]) {
      setFormErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };
  const saveRemarks = async (catId, newRemarks, oldRemarks) => {
    const toAdd = newRemarks.filter(r => r.id === null);
    const newIds = new Set(newRemarks.filter(r => r.id !== null).map(r => r.id));
    const toDelete = oldRemarks.filter(r => !newIds.has(r.id));

    await Promise.all([
      ...toAdd.map(r =>
        fetch(buildApiUrl('/catalog/remark/create'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
          body: JSON.stringify({ catId: catId, remark_name: r.remark_name }),
        })
      ),
      ...toDelete.map(r =>
        fetch(buildApiUrl('/remark'), {
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
          body: JSON.stringify({ id: r.id }),
        })
      ),
    ]);
  };

  const NAME_MAX = 50;
  const DESC_MAX = 50;

  // 打印机校验逻辑独立，不再嵌套在 else if 链中
  const validate = () => {
    const errors = {};
    console.log("validate====>", form);
    


    if (!form.catName) {
      errors.catName = 'Category name is required.';
    } else if (form.catName.length > NAME_MAX) {
      errors.catName = `Category name cannot exceed ${NAME_MAX} characters.`;
    }

    if (!form.catDesc) {
      errors.catDesc = 'Category description is required.';
    } else if (form.catDesc.length > DESC_MAX) {
      errors.catDesc = `Description cannot exceed ${DESC_MAX} characters.`;
    }

    // 打印机校验：独立判断
    if (!form.printerReference) {
      errors.printerReference = 'Please select a printer.';
    }

    if (!form.isTake) { errors.isTake = 'Please select a isTake.'; }

    if (!form.status) {
      errors.status = 'Please select an option.';
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };


  const handleCreate = async () => {
    if (!validate()) return;

    const categoryDtoData = {
      catName: form.catName,
      catDesc: form.catDesc,
      status: form.status,
      remarks: remarks.map(r => ({ remarkName: r.remark_name })),
      tenantReference: selectedRestaurant?.reference,
      printerReference: form.printerReference || null,
      isTake: String(form.isTake) || null,
    };

    // 有图片时转 base64 放入 JSON，
    if (imageFile) {
      const base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(imageFile);
      });
      categoryDtoData.imageUrl = base64;
    }

    try {
      const response = await fetch(buildApiUrl('/catalog/category/create'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
        body: JSON.stringify(categoryDtoData),
      });

      const data = await response.json();

      if (data.code === 200) {
        notify(data.message || 'Category created successfully!', 'success');
        backToList();
        fetchCategories(selectedRestaurant?.reference);
      } else {
        notify(data.message || data.msg || 'Failed to create category.', 'error');
      }
    } catch (err) {
      console.error('Failed to create category.', err);
      notify('Failed to create category: ' + err.message, 'error');
    }
  };


  const handleUpdate = async () => {
    if (!validate()) return;

    const categoryDtoData = {
      reference: form.reference,
      catName: form.catName,
      catDesc: form.catDesc,
      status: form.status,
      remarks: remarks.map(r => ({ remarkName: r.remark_name })),
      tenantReference: selectedRestaurant?.reference,
      printerReference: form.printerReference || null,
      catPic: form.catPic || null,
      isTake: String(form.isTake) || null,
    };


    // 有图片时转 base64 放入 JSON，
    if (imageFile) {
      const base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(imageFile);
      });
      categoryDtoData.imageUrl = base64;
    }


    try {
      const response = await fetch(buildApiUrl('/catalog/category/update'), {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
        body: JSON.stringify(categoryDtoData),
      });

      const data = await response.json();

      if (data.code === 200) {
        notify(data.message || 'Category updated successfully!', 'success');
        backToList();
        fetchCategories(selectedRestaurant?.reference);
      } else {
        notify(data.message || data.msg || 'Failed to update category.', 'error');
      }
    } catch (err) {
      console.error('Failed to update category', err);
      notify('Failed to update category: ' + err.message, 'error');
    }
  };

  // Deleting a Category
  const handleDelete = async () => {
    if (!(await confirm('Are you sure you want to delete this category?'))) return;

    const submitData = new FormData();

    const categoryDtoData = {
      id: form.id,
    };

    const categoryBlob = new Blob(
      [JSON.stringify(categoryDtoData)],
      { type: 'application/json' }
    );

    submitData.append('category', categoryBlob);

    try {
      const response = await fetch(buildApiUrl('/catalog/category/delete'), {
        method: 'DELETE',
        headers: getAuthHeaders(),
        body: submitData,
      });

      const data = await response.json();
      if (data.code === 200) {
        notify(data.message || 'Category deleted successfully!', 'success');
        backToList();
        fetchCategories(selectedRestaurant?.reference);
      } else {
        notify(data.message || 'Failed to delete category.', 'error');
      }
    } catch (err) {
      console.error('Failed to delete category', err);
    }
  };

  const { items: navItems, icons: navIcons } = getFilteredNavItemsWithIcons();

  const renderSidebar = () => (
    <nav className="sidebar">
      <div className="sidebar-title">Restaurant Management</div>
      <ul>
        {navItems.map(item => (
          <li key={item} className={item === 'Categories' ? 'active' : ''} onClick={() => item === 'Categories' ? backToList() : handleNavClick(item)}>
            <span className="nav-icon">{navIcons[item]}</span> {item}
          </li>
        ))}
      </ul>
    </nav>
  );

  const renderDescriptionEditor = () => (
    <div className="cat-editor-wrap">
      <textarea
        className={`cat-editor-area${formErrors.catDesc ? ' cat-input-error' : ''}`}
        name="catDesc"
        value={form.catDesc}
        onChange={handleFormChange}
        placeholder="Provide a detailed description of your category"
        maxLength={DESC_MAX + 1}
      />
    </div>
  );

  const hasChanges = view === 'add'
    ? (form.catName !== '' || form.catDesc !== '' || imageFile !== null)
    : (
      form.catName !== originalForm.catName ||
      form.catDesc !== originalForm.catDesc ||
      form.status !== originalForm.status ||
      form.printerReference !== originalForm.printerReference ||
      imageFile !== null ||
      JSON.stringify(remarks) !== JSON.stringify(originalRemarks)
    );

  if (view === 'add' || view === 'edit') {
    return (
      <div className="categories-wrapper">
        {renderSidebar()}
        <main className="categories-main">
          <h1 className="cat-form-title">{view === 'add' ? 'Add New Category' : 'Edit Category'}</h1>

          <div className="cat-form-wrap">
            <div className="cat-form-card">
              <div className="cat-form-field">
                <label>Category Name <span className="required">*</span></label>
                <input
                  className={`cat-form-input${formErrors.catName ? ' cat-input-error' : ''}`}
                  name="catName"
                  value={form.catName}
                  onChange={handleFormChange}
                  placeholder="Enter category name"
                  maxLength={NAME_MAX + 1}
                />
                {formErrors.catName && <p className="cat-field-error">{formErrors.catName}</p>}
              </div>

              <div className="cat-form-field">
                <label>Category Description <span className="required">*</span></label>
                {renderDescriptionEditor()}
                {formErrors.catDesc && <p className="cat-field-error">{formErrors.catDesc}</p>}
              </div>

              <div className="cat-form-field">
                {view === 'edit' && imagePreview ? (
                  <div className="cat-img-edit-wrap">
                    <img src={imagePreview} alt="Category" className="cat-img-thumb" />
                    <button type="button" className="cat-img-edit-icon" onClick={() => imageInputRef.current.click()}>
                      <FiEdit2 />
                    </button>
                  </div>
                ) : (
                  <button type="button" className="cat-upload-btn" onClick={() => imageInputRef.current.click()}>
                    Upload Category Images
                  </button>
                )}
                <input
                  ref={imageInputRef}
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  style={{ display: 'none' }}
                />
                {view === 'add' && imagePreview && (
                  <img src={imagePreview} alt="Preview" className="cat-img-thumb" style={{ marginTop: 12 }} />
                )}
              </div>

              <div className="cat-form-field">
                <label>Remark</label>
                <div className="cat-remark-box">
                  {remarks.map((r, i) => (
                    <span key={i} className="cat-remark-tag">
                      {r.remark_name}
                      <button type="button" className="cat-remark-remove" onClick={() => removeRemark(i)}>×</button>
                    </span>
                  ))}
                  {showRemarkInput ? (
                    <input
                      className="cat-remark-input"
                      value={remarkInput}
                      onChange={e => setRemarkInput(e.target.value)}
                      onKeyDown={e => { if (e.key === 'Enter') addRemark(); if (e.key === 'Escape') { setShowRemarkInput(false); setRemarkInput(''); } }}
                      onBlur={addRemark}
                      autoFocus
                      maxLength={20}
                      placeholder="Enter remark"
                    />
                  ) : (
                    <button type="button" className="cat-remark-add" onClick={() => setShowRemarkInput(true)}>+</button>
                  )}
                </div>
              </div>

              {/* 选择 */}
              <div className='cat-form-select-nav'>
                {/* ── Status ── */}
                <div className="cat-form-field">
                  <label>Status <span className="required">*</span></label>
                  <select
                    className="cat-form-select"
                    name="status"
                    value={form.status}
                    onChange={handleFormChange}
                  >
                    <option value="1">Published</option>
                    <option value="0">Unpublished</option>
                  </select>
                </div>

                {/* ── Print ── */}
                <div className="cat-form-field cat-form-select-nav-mar-lef-20">
                  <label>Printer <span className="required">*</span></label>
                  <select
                    className={`cat-form-select${formErrors.printerReference ? ' cat-input-error' : ''}`}
                    name="printerReference"
                    value={form.printerReference || ''}
                    onChange={handleFormChangePrint}
                  >
                    <option value="">-- Select Printer --</option>
                    {prinList.map((printer) => (
                      <option key={printer.id} value={printer.reference}>
                        {printer.printerName}
                      </option>
                    ))}
                  </select>
                  {formErrors.printerReference && (
                    <p className="cat-field-error">{formErrors.printerReference}</p>
                  )}
                </div>



              </div>
              {/* ── isTake  ── */}
              <div className="cat-form-field cat-form-select-nav-mar-lef-10">
                <label>Order Type <span className="required">*</span></label>
                <select
                  className={`cat-form-select${formErrors.isTake ? ' cat-input-error' : ''}`}
                  name="isTake"
                  value={form.isTake || ''}
                  onChange={handleFormChangeisTak}
                >
                  <option value="">-- Select isTake --</option>
                  <option value="1">Catering</option>
                  <option value="0">Normal</option>
                </select>
                {formErrors.isTake && (
                  <p className="cat-field-error">{formErrors.isTake}</p>
                )}
              </div>
            </div>

            <div className="cat-form-actions">
              <button className="cancel-btn" onClick={backToList}>Cancel</button>
              {/* <button className={`submit-btn${hasChanges ? '' : ' submit-btn-inactive'}`} onClick={view === 'add' ? handleCreate : handleUpdate}> */}
              <button className={`submit-btn`} onClick={view === 'add' ? handleCreate : handleUpdate}>
                Save Changes
              </button>
            </div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="categories-wrapper">
      {renderSidebar()}
      <main className="categories-main">
        <div className="categories-header">
          <div>
            <h1 className="categories-title">Categories</h1>
            <p className="categories-subtitle">Manage your restaurant categories</p>
          </div>
          <HasPermi permission={['catalog:category:create']}>
            <button className="cat-page-add-btn" onClick={openAdd}>
              <FiPlusCircle /> Add Category
            </button>
          </HasPermi>
        </div>

        <div className="categories-toolbar">
          <div className="cat-search-box">
            <FaSearch className="cat-search-icon" />
            <input
              type="text"
              placeholder="Search Categories..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>
          <div className="cat-status-filter">
            <span className="cat-status-label">Status</span>
            <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
              <option>All</option>
              <option>Published</option>
              <option>Unpublished</option>
            </select>
          </div>
        </div>

        {isLoading ? (
          <p className="cat-loading">Loading...</p>
        ) : (
          <div className="categories-grid">
            {filtered.map(category => (
              <div key={category.id} className="category-card">
                <HasPermi permission={['catalog:category:update']}>
                  <button className="category-card-edit" onClick={() => openEdit(category)}>
                    <FiEdit2 />
                  </button>
                </HasPermi>
                <div className="category-card-img-wrap">
                  {category.catPic
                    ? <img
                      // src={buildApiUrl(`/file/view?fileName=${category.catPic.split('/').pop()}`)}
                      src={category.catPic}
                      alt={category.catName}
                      className="category-card-img"
                    />
                    : <div className="category-card-img-placeholder" />
                  }
                </div>
                <div className="category-card-body">
                  <div className="category-card-name">{category.catName}</div>
                  <div className="category-card-desc">{category.catDesc}</div>
                  <span className={`category-status-badge ${category.status === 1 ? 'cat-published' : 'cat-unpublished'}`}>
                    {category.status === 1 ? 'Published' : 'Unpublished'}
                  </span>
                </div>
              </div>
            ))}
            {filtered.length === 0 && (
              <p className="cat-empty">No categories found.</p>
            )}
          </div>
        )}
      </main>
    </div>
  );
}

export default CategoriesPage;